<div class="conteudo-pagamento pix-pagamento" *ngIf="pix?.disponivel !== false">
  <img class="pix" *ngIf="imagemQrCode" [src]="imagemQrCode" alt="QR Code Pix">
  <button type="button" *ngIf="pix?.qrcodeText && !mensagemCopiada"
          class="btn btn-outline-secondary btn-copia" (click)="copie()">Pix Copia e Cola</button>
  <button type="button" *ngIf="mensagemCopiada" class="btn btn-success btn-copia">Pix Copiado</button>
  <p>Escaneie o QR Code no aplicativo do seu banco ou use o código Pix copia e cola.</p>
</div>
